<template>
  <ValidationProvider :name="label" :rules="rules" v-slot="{ errors }">
    <label class="form-label">
      {{ label }}
      <span v-if="required" class="text-danger">*</span>
    </label>
    <textarea
        class="form-control"
        :placeholder="placeholder"
        v-model="valueProxy"
        :disabled="disabled"
        :rows="rows"
    ></textarea>
    <small class="text-danger">{{ errors[0] }}</small>
  </ValidationProvider>
</template>

<script>
  export default {
    name: "TextareaField",
    props: {
      label: String,
      value: String,
      placeholder: String,
      rules: String,
      required: Boolean,
      disabled: Boolean,
      rows: {
        type: Number,
        default: 3
      }
    },
    computed: {
      valueProxy: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit("input", val);
        }
      }
    }
  };
</script>
